import { render, staticRenderFns } from "./UiHtmlarea.vue?vue&type=template&id=745cdf53&scoped=true&"
import script from "./UiHtmlarea.vue?vue&type=script&lang=js&"
export * from "./UiHtmlarea.vue?vue&type=script&lang=js&"
import style0 from "./UiHtmlarea.vue?vue&type=style&index=0&lang=css&"
import style1 from "./UiHtmlarea.vue?vue&type=style&index=1&id=745cdf53&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745cdf53",
  null
  
)

export default component.exports